"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  {\n    getOrganisations {\n      name\n      organisationId\n      alias\n      imageUrl\n      invitedUserEmail\n      accountManager {\n        userId\n      }\n      package {\n        slaTurnaround\n        templatedFrom\n        videoQuantity\n        storageAllowance\n        amendmentsQuantity\n        subStart\n        subEnd\n      }\n      defaultUser {\n        imageUrl\n        firstName\n        lastName\n        phoneNumber\n        email\n        officeLocation\n      }\n      status\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getOrganisationsQuery = (0, _graphqlTag.default)(_templateObject());

var getOrganisations = function getOrganisations() {
  return {
    query: getOrganisationsQuery,
    module: 'organisations',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {};
    }
  };
};

var _default = getOrganisations;
exports.default = _default;